/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, {Component} from 'react';
// material
import { Form, Grid, GridSet, GridItem, TextField } from '@insticator/insticator-ui'; // iui-material
//styles
import styles from 'pages/dashboard/account/paymentinfo/selectmethod/paypal/paypal_styles';
import injectSheet from 'react-jss';



/* ========== ~~~~~~~~~~ PAYPAL ~~~~~~~~~~ ========== */
class Paypal extends Component {
    constructor(props){
        super(props);
        this.formName = 'PAYPAL';
    }

    componentDidMount(){
   if(this.props.paymentUUID)this.props.getPayPalInformation(false, this.formName, this.props.paymentUUID);
    }

    render() {

        return(
         <Form formName={this.formName} editable={this.props.editable}>
            <Grid  klass={`paypal ${this.props.classes.paypal}`}>
                <GridSet align={`horizontal`} >
                    <GridItem type={`full`}>
                        <TextField type={`text`} name={`paypalUserName`} value={this.props.fields.paypalUserName.value} valid={this.props.fields.paypalUserName.valid} formName={this.formName} placeholder={`PayPal username`} label={`Paypal Username`} info={``} required />
                    </GridItem>
                </GridSet>
            </Grid>
         </Form>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Paypal);
